module.exports = __webpack_public_path__ + "static/media/referral-points.e574df9c.svg";